/**
 * Mobile Navigation Animation
 */

(function($) {

	$(document).ready(function() {

		// elements and heights
		var header   = $( 'header[role=banner]' );
		var nav      = $( 'nav', header );

 		/**
		 * Toggler: toggle class and position menu
		 */
		$( '#menu-toggle' ).click( function(){
			nav.slideToggle();
		});


		/**
		 * Add submenu dropdown toggles
		 */
		$( 'a', '.menu-item-has-children' ).first().after(
			'<button class="toggle-sub"><span class="screen-reader-text">Menu</span></button>'
		);

		// on toggle click
		$( '.toggle-sub' ).click( function(){

			// var li = $(this).closest('li');
			// li.toggleClass( 'sub-toggled' );

			$(this).next('ul.sub-menu').slideToggle();
			$(this).next('ul.sub-menu').toggleClass( 'sub-toggled' );
			$(this).toggleClass( 'open' );

		});

	}); // document.ready
})(jQuery);
